import React, { Component, type ErrorInfo, type ReactNode } from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; }

export class AppErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[DataGrid XML] Erro capturado pelo ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground p-8">
          <div className="max-w-lg w-full glass-card p-8 space-y-6 text-center">
            <div className="size-16 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center mx-auto">
              <AlertTriangle className="size-8 text-red-500" />
            </div>
            <h1 className="text-2xl font-black tracking-tight">Algo deu errado</h1>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Ocorreu um erro inesperado na aplicação. Clique em recarregar para tentar novamente.
              Se o problema persistir, limpe os dados do navegador (localStorage).
            </p>
            <div className="pt-2">
              <button
                onClick={() => {
                  try { 
                    localStorage.clear(); 
                    sessionStorage.clear(); 
                    // Limpar bancos de dados se possível
                    window.indexedDB.databases().then(dbs => {
                      dbs.forEach(db => { if (db.name) window.indexedDB.deleteDatabase(db.name); });
                    });
                  } catch {}
                  window.location.href = "/";
                }}
                className="btn-primary w-full h-14 rounded-2xl flex items-center justify-center gap-3 text-xs font-black tracking-[0.2em] shadow-xl shadow-primary/20"
              >
                <RefreshCw className="size-5" />
                LIMPAR E RECARREGAR SISTEMA
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
